module.exports = __webpack_public_path__ + "static/emoji2-13a2791a80b116dabe1ef5b63766552a.gif";